import * as React from 'react';
import { fullContainer } from '../styles/styleObjects';
import { InformationIcon } from './InformationIcon';

interface IProps extends React.DetailedHTMLProps<React.InputHTMLAttributes<HTMLInputElement>, HTMLInputElement> {
    containerStyle: React.CSSProperties;
    textStyle?: React.CSSProperties;
    onChangeText?(text: string): void;
    header: string | null;
    placeholder?: string;
    type?: string;
    value?: string;
    sideButton?(focus?: () => void): JSX.Element;
    disabled?: boolean;
    children?: React.ReactNode;
    inputClassName?: string;
    maxLength?: number;
    showMaxLengthOnFocus?: boolean;
    hideButtonOnFocus?: boolean;
    helpLink?: string;
}

interface IState {
    shouldShowCharacterCount: boolean;
    inputRef: any;
}
export class CommonTextInput extends React.Component<IProps, IState> {
    public state: IState = {
        shouldShowCharacterCount: !!this.props.showMaxLengthOnFocus,
        inputRef: undefined
    };

    private setShouldShowCharacterCount(show: boolean): void {
        if (this.props.showMaxLengthOnFocus === undefined || !this.props.showMaxLengthOnFocus) {
            return;
        }

        this.setState({ shouldShowCharacterCount: show });
    }

    public render() {
        const { children, containerStyle, header, inputClassName, disabled, placeholder, type, textStyle, onChangeText, value, maxLength, sideButton, ...props } = this.props;

        const inputProps = Object.keys(props).reduce((object: any, key) => {
            // this is because we do {...inputProps}. We shouldn't be doing this..
            if (key !== 'showMaxLengthOnFocus' && key !== 'hideButtonOnFocus' && key !== 'helpLink') {
                object[key] = (props as any)[key];
            }
            return object;
        }, {});

        return (
            <div style={{ ...styles.container, ...containerStyle }}>
                {header !== null && (
                    <div style={styles.headerAndLengthContainer}>
                        <h4 style={styles.headerText}>{header}</h4>
                        {maxLength !== null && this.state.shouldShowCharacterCount && <h4 style={styles.lengthText}>{`${(value || '').length}/${maxLength}`}</h4>}
                    </div>
                )}
                {children || (
                    <input
                        ref={ref => (this.state.inputRef === undefined ? this.setState({ inputRef: ref }) : {})}
                        onFocus={() => this.setShouldShowCharacterCount(true)}
                        onBlur={() => this.setShouldShowCharacterCount(false)}
                        className={inputClassName}
                        disabled={disabled}
                        placeholder={placeholder}
                        type={type || 'text'}
                        style={{ ...styles.input, ...textStyle, ...(sideButton ? { paddingRight: 70 } : {}) }}
                        onChange={event => onChangeText!(event.target.value)}
                        value={value}
                        maxLength={maxLength}
                        {...inputProps}
                    />
                )}
                {this.state.inputRef &&
                    sideButton &&
                    (this.props.hideButtonOnFocus ? !this.state.shouldShowCharacterCount : true) &&
                    sideButton(() => this.state.inputRef.focus())}

                {this.props.helpLink && <InformationIcon style={styles.link} link={this.props.helpLink} />}
            </div>
        );
    }
}

const styles = {
    link: {
        position: 'absolute',
        right: -40,
        top: 26
    } as React.CSSProperties,
    headerAndLengthContainer: {
        display: 'flex',
        justifyContent: 'space-between'
    } as React.CSSProperties,
    container: {
        borderRadius: 2,
        position: 'relative'
    } as React.CSSProperties,
    input: {
        outline: 'none',
        border: 'none',
        backgroundColor: 'transparent',
        paddingLeft: 18,
        fontSize: 20,
        paddingRight: 18,
        paddingBottom: 8,
        textOverflow: 'ellipsis',
        ...fullContainer
    },
    headerText: {
        position: 'relative',
        top: 12,
        left: 18,
        color: '#737373',
        fontSize: 14,
        fontWeight: 600
    } as React.CSSProperties,
    lengthText: {
        position: 'relative',
        fontSize: 14,
        top: 12,
        right: 18
    } as React.CSSProperties
};



// WEBPACK FOOTER //
// ./src/SharedComponents/CommonTextInput.tsx